import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "row mx-n2" }
const _hoisted_2 = { class: "hovered-check-wrap" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "file-info" }
const _hoisted_5 = { class: "iconed-block-list" }
const _hoisted_6 = {
  key: 0,
  class: "icon-wrap"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-excel" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "icon-wrap"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-image" }, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "icon-wrap"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" }, null, -1)
const _hoisted_12 = {
  key: 3,
  class: "icon-wrap"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-excel" }, null, -1)
const _hoisted_14 = {
  key: 4,
  class: "icon-wrap"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_16 = {
  key: 5,
  class: "icon-wrap"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-csv" }, null, -1)
const _hoisted_18 = {
  key: 6,
  class: "icon-wrap"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-video" }, null, -1)
const _hoisted_20 = { class: "fig-wrapp text-left" }
const _hoisted_21 = { class: "image-wrap" }
const _hoisted_22 = {
  key: 0,
  class: "image-wrapp"
}
const _hoisted_23 = {
  key: 1,
  src: "https://www.learningcontainer.com/wp-content/uploads/2020/05/Sample-Text-FIle.jpeg?ezimgfmt=ng%3Awebp%2Fngcb4%2Frs%3Adevice%2Frscb4-1",
  alt: ""
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 2,
  class: "embed-responsive embed-responsive-21by9"
}
const _hoisted_26 = { class: "vjs-no-js" }
const _hoisted_27 = {
  href: "https://videojs.com/html5-video-support/",
  target: "_blank"
}
const _hoisted_28 = { class: "doted-list my-1" }
const _hoisted_29 = {
  key: 0,
  class: "activity-block p-0"
}
const _hoisted_30 = { class: "inline-list" }
const _hoisted_31 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-tags" })
], -1)
const _hoisted_33 = { class: "file-actions" }
const _hoisted_34 = { class: "dropdown" }
const _hoisted_35 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_36 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "fas fa-folder-open" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-share-alt mr-2" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt mr-2" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fas fa-tags" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download mr-2" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "fa fa-comments" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenameDocumentModal = _resolveComponent("RenameDocumentModal")
  const _component_DeleteModal = _resolveComponent("DeleteModal")
  const _component_DetailModal = _resolveComponent("DetailModal")
  const _component_MyDriveFileTags = _resolveComponent("MyDriveFileTags")
  const _component_DetailviewModal = _resolveComponent("DetailviewModal")
  const _component_ShareModal = _resolveComponent("ShareModal")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.files, (file, fileIndex) => {
        return (_openBlock(), _createBlock("div", {
          class: "col-lg-3 col-md-4 col-sm-6 px-2 mb-2",
          key: fileIndex
        }, [
          _createVNode("div", {
            class: 
          file.isChecked
            ? 'shadowed-card bg-white mb-2 doc-card doc-active-card'
            : 'shadowed-card bg-white mb-2 doc-card'
        
          }, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  id: "checkbox",
                  name: "checkbox1",
                  value: "",
                  onClick: ($event: any) => (_ctx.selectFile(file)),
                  "onUpdate:modelValue": ($event: any) => (file.isChecked = $event)
                }, null, 8, ["onClick", "onUpdate:modelValue"]), [
                  [_vModelCheckbox, file.isChecked]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    (file.filetype === 'xsls')
                      ? (_openBlock(), _createBlock("span", _hoisted_6, [
                          _hoisted_7
                        ]))
                      : _createCommentVNode("", true),
                    (
                    file.filetype === 'png' ||
                    file.filetype === 'jpg' ||
                    file.filetype === 'jpeg'
                  )
                      ? (_openBlock(), _createBlock("span", _hoisted_8, [
                          _hoisted_9
                        ]))
                      : _createCommentVNode("", true),
                    (file.filetype === 'doc' || file.filetype === 'docx')
                      ? (_openBlock(), _createBlock("span", _hoisted_10, [
                          _hoisted_11
                        ]))
                      : _createCommentVNode("", true),
                    (file.filetype === 'xls' || file.filetype === 'xlsx')
                      ? (_openBlock(), _createBlock("span", _hoisted_12, [
                          _hoisted_13
                        ]))
                      : _createCommentVNode("", true),
                    (file.filetype === 'pdf')
                      ? (_openBlock(), _createBlock("span", _hoisted_14, [
                          _hoisted_15
                        ]))
                      : _createCommentVNode("", true),
                    (file.filetype === 'csv')
                      ? (_openBlock(), _createBlock("span", _hoisted_16, [
                          _hoisted_17
                        ]))
                      : _createCommentVNode("", true),
                    (
                    file.filetype === 'mov' ||
                    file.filetype === 'MOV' ||
                    file.filetype === 'mp4' ||
                    file.filetype === 'quicktime'
                  )
                      ? (_openBlock(), _createBlock("span", _hoisted_18, [
                          _hoisted_19
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        (file.filetype === 'png' || file.filetype === 'jpg')
                          ? (_openBlock(), _createBlock("div", _hoisted_22, [
                              (file.file_url)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: file.file_url,
                                    alt: ""
                                  }, null, 8, ["src"]))
                                : (_openBlock(), _createBlock("img", _hoisted_23))
                            ]))
                          : _createCommentVNode("", true),
                        (file.filetype === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_24, [
                              _createVNode("iframe", {
                                src: file.file_url,
                                frameBorder: "0",
                                scrolling: "auto",
                                height: "100%",
                                width: "100%"
                              }, null, 8, ["src"])
                            ]))
                          : _createCommentVNode("", true),
                        (
                        file.filetype === 'mov' ||
                        file.filetype === 'MOV' ||
                        file.filetype === 'mp4' ||
                        file.filetype === 'quicktime'
                      )
                          ? (_openBlock(), _createBlock("div", _hoisted_25, [
                              _createVNode("video", {
                                id: `my-player${fileIndex}`,
                                class: "video-js",
                                controls: "",
                                preload: "auto",
                                poster: "img/convorally-logo.png",
                                "data-setup": "{}"
                              }, [
                                _createVNode("source", {
                                  src: file.file_url,
                                  type: `video/${file.filetype}`
                                }, null, 8, ["src", "type"]),
                                _createVNode("p", _hoisted_26, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('enable_javascript_message')) + " ", 1),
                                  _createVNode("a", _hoisted_27, _toDisplayString(_ctx.$t('supports_html5_video')), 1)
                                ])
                              ], 8, ["id"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode("h5", null, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.showPreview(file))
                      }, _toDisplayString(file.filename), 9, ["onClick"])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode("ul", null, [
                  _createVNode("li", null, _toDisplayString(_ctx.formatDate(file.created_date)), 1),
                  _createVNode("li", null, _toDisplayString(file.convertedFileSize), 1)
                ])
              ])
            ]),
            (file.file_tag)
              ? (_openBlock(), _createBlock("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(file.file_tag, (tag, tagIndex) => {
                        return (_openBlock(), _createBlock("li", {
                          class: "pl-0 pr-1",
                          key: tagIndex
                        }, [
                          (tag.master_file_tag && tag.master_file_tag.name)
                            ? (_openBlock(), _createBlock("a", _hoisted_31, [
                                _hoisted_32,
                                _createTextVNode(" " + _toDisplayString(tag.master_file_tag.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_33, [
              _createVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode("div", _hoisted_36, [
                  (file.breadcrumb && file.breadcrumb.length)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        class: "dropdown-item",
                        href: "javascript:void(0)",
                        "data-toggle": "modal",
                        onClick: ($event: any) => (_ctx.redirectToDirectory(file))
                      }, [
                        _hoisted_37,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('go_to_directory')), 1)
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode("a", {
                    class: "dropdown-item",
                    href: "javascript:void(0)",
                    "data-toggle": "modal",
                    onClick: ($event: any) => (_ctx.showDetailModal(file))
                  }, [
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('details')), 1)
                  ], 8, ["onClick"]),
                  _createVNode("a", {
                    class: "dropdown-item",
                    href: "javascript:void(0)",
                    "data-toggle": "modal",
                    onClick: ($event: any) => (_ctx.showShareModal(file))
                  }, [
                    _hoisted_39,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('share')), 1)
                  ], 8, ["onClick"]),
                  _createVNode("a", {
                    class: "dropdown-item",
                    href: "javascript:void(0)",
                    "data-toggle": "modal",
                    onClick: ($event: any) => (_ctx.showRenameModal(file))
                  }, [
                    _hoisted_40,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('rename')), 1)
                  ], 8, ["onClick"]),
                  _createVNode("a", {
                    class: "dropdown-item",
                    href: "javascript:void(0)",
                    onClick: ($event: any) => (_ctx.showAddTag(file))
                  }, [
                    _hoisted_41,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('add_tag')), 1)
                  ], 8, ["onClick"]),
                  _createVNode("a", {
                    class: "dropdown-item",
                    href: "javascript:void(0)",
                    onClick: ($event: any) => (_ctx.downloadFile(file))
                  }, [
                    _hoisted_42,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ], 8, ["onClick"]),
                  (file.communication_id && file.channel_uuid)
                    ? (_openBlock(), _createBlock("a", {
                        key: 1,
                        class: "dropdown-item",
                        href: "javascript:void(0)",
                        "data-toggle": "modal",
                        onClick: ($event: any) => (_ctx.goToChatChannel(file))
                      }, [
                        _hoisted_43,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('go_to_chat')), 1)
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode("a", {
                    class: "dropdown-item",
                    href: "javascript:void(0)",
                    "data-toggle": "modal",
                    onClick: ($event: any) => (_ctx.showDeleteFolderModal(file))
                  }, [
                    _hoisted_44,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                  ], 8, ["onClick"])
                ])
              ])
            ])
          ], 2)
        ]))
      }), 128))
    ]),
    (_ctx.state.data.showRenameFileModal)
      ? (_openBlock(), _createBlock(_component_RenameDocumentModal, {
          key: 0,
          onRename: _ctx.closeRenameModal,
          showModal: _ctx.state.data.showRenameFileModal,
          fileId: _ctx.state.data.selectedFolder.uuid,
          rename: _ctx.state.data.selectedFolder.filename
        }, null, 8, ["onRename", "showModal", "fileId", "rename"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showDeleteModal)
      ? (_openBlock(), _createBlock(_component_DeleteModal, {
          key: 1,
          onClose: _ctx.closeDeleteModal,
          showModal: _ctx.state.data.showDeleteModal,
          fileId: _ctx.state.data.selectedFolder.uuid
        }, null, 8, ["onClose", "showModal", "fileId"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showDetailModal)
      ? (_openBlock(), _createBlock(_component_DetailModal, {
          key: 2,
          onClose: _ctx.closeDetailModal,
          showModal: _ctx.state.data.showDetailModal,
          selected: _ctx.state.data.selectedFolder
        }, null, 8, ["onClose", "showModal", "selected"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showAddTagModal)
      ? (_openBlock(), _createBlock(_component_MyDriveFileTags, {
          key: 3,
          onClose: _ctx.closeMyDriveFileTags,
          showModal: _ctx.state.data.showAddTagModal,
          selected: _ctx.state.data.selectedFolder
        }, null, 8, ["onClose", "showModal", "selected"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showDetailViewModal)
      ? (_openBlock(), _createBlock(_component_DetailviewModal, {
          key: 4,
          onClose: _ctx.closeDetailViewModal,
          onSelectedFile: _ctx.closeDetailViewModal,
          showModal: _ctx.state.data.showDetailViewModal,
          selected: _ctx.state.data.selectedFolder
        }, null, 8, ["onClose", "onSelectedFile", "showModal", "selected"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showShareModal)
      ? (_openBlock(), _createBlock(_component_ShareModal, {
          key: 5,
          showModal: _ctx.state.data.showShareModal,
          selectedFiles: _ctx.state.data.selectedFiles,
          onClose: _ctx.closeShareModal
        }, null, 8, ["showModal", "selectedFiles", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 6,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}